import { Card, CardContent } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";

export default function CreateLabPage() {
  return (
    <Card className="max-w-xl mx-auto mt-10 p-6">
      <h2 className="text-2xl font-bold mb-4">Create Lab</h2>
      <CardContent className="space-y-4">
        <Input placeholder="Lab Name" />
        <Input placeholder="Lab Email" />
        <Input placeholder="Contact Number" />

        <Button>Create Lab</Button>
      </CardContent>
    </Card>
  );
}
